module.exports = __webpack_public_path__ + "img/energy_yichangshibie.33dfb181.png";